export default __webpack_public_path__ + "static/media/king.12ea22f8.png";